// extracted by mini-css-extract-plugin
module.exports = {"hidden":"result_hidden__pesny","textEmphasis":"result_textEmphasis__M73fQ","wrap":"result_wrap__jzhTk","v3":"result_v3__3lESs","resultArea":"result_resultArea__rnxrR"};